import { State } from '@progress/kendo-data-query'

import {
  LOADING_HISTORICO_RESERVAS,
  LOADING_PROVEEDORES_RESERVAS,
  SET_ORDEN_PEDIDO,
  SET_PROVEEDORES_RESERVAS,
  SET_PROVEEDOR_SELECT,
  SET_HISTORY_RESERVAS,
  SET_DATASTATE,
  CLEAR_FILTROS_RESERVAS,
  SET_TIPO_RESERVA,
  SET_DATE_FILTER,
  CLEAR_DATE_FILTER,
  RESET_GRID_KEY,
} from './type'

import { TAKE } from '@/common/constants/default'
import { Action } from '@/common/interfaces/general'

export interface ItemProveedor {
  ProveedorId: number
  NombreCompleto: string
}

export interface DateFilter {
  startDate: Date | null
  endDate: Date | null
  filterType: 'reserva' | 'historico'
}

export interface StateReservasHistorico {
  loading: boolean
  loadProveedores: boolean
  proveedores: ItemProveedor[]
  proveedorSelect: ItemProveedor
  ordenPedido: number
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any[]
  dataState: State
  tipoReserva: string
  dateFilter: DateFilter
  gridKey: number
}

export const initialBookingState: State = {
  take: TAKE,
  skip: 0,
}

const INITIAL_STATE: StateReservasHistorico = {
  loading: false,
  loadProveedores: false,
  data: [],
  proveedores: [],
  proveedorSelect: {} as ItemProveedor,
  ordenPedido: 0,
  tipoReserva: 'ReservaCentralizada',
  dataState: initialBookingState,
  dateFilter: {
    startDate: null,
    endDate: null,
    filterType: 'historico',
  },
  gridKey: 0,
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const action: Action<any> = {
  type: '',
  payload: '',
}
const ReservasHistorico = (
  state = INITIAL_STATE,
  { type, payload } = action,
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
) => {
  switch (type) {
    case LOADING_HISTORICO_RESERVAS:
      return {
        ...state,
        loading: payload,
      }

    case LOADING_PROVEEDORES_RESERVAS:
      return {
        ...state,
        loadProveedores: payload,
      }

    case SET_PROVEEDORES_RESERVAS:
      return {
        ...state,
        proveedores: payload,
      }

    case SET_PROVEEDOR_SELECT:
      return {
        ...state,
        proveedorSelect: payload,
      }

    case SET_TIPO_RESERVA:
      return {
        ...state,
        tipoReserva: payload,
      }

    case SET_ORDEN_PEDIDO:
      return {
        ...state,
        ordenPedido: payload,
      }

    case SET_HISTORY_RESERVAS:
      return {
        ...state,
        data: payload,
      }

    case SET_DATASTATE:
      return {
        ...state,
        dataState: payload,
      }

    case SET_DATE_FILTER:
      return {
        ...state,
        dateFilter: payload,
      }

    case CLEAR_FILTROS_RESERVAS:
      return {
        ...state,
        data: [],
        dataState: initialBookingState, // Reset grid filters and sorting
        dateFilter: {
          startDate: null,
          endDate: null,
          filterType: 'historico',
        },
        gridKey: state.gridKey + 1, // Force Grid re-render to clear column filters
      }

    case CLEAR_DATE_FILTER:
      return {
        ...state,
        dateFilter: {
          startDate: null,
          endDate: null,
          filterType: 'historico',
        },
      }

    case RESET_GRID_KEY:
      return {
        ...state,
        gridKey: state.gridKey + 1,
      }

    default:
      return state
  }
}

export default ReservasHistorico
